import React from 'react';
import { DialogUI } from '../../Interface';
import ProductionMain from './ProductionMain';

const ProductionDialog = ({ showDialog, onClose, selectedOrderData }) => {
  return (
    <DialogUI
      open={showDialog}
      headerContent={'Gyártás'}
      fullWidth={true}
      onClose={onClose}
      closeBtn={true}
      maxWidth="xl"
    >
      <ProductionMain selectedOrderData={selectedOrderData}  />
    </DialogUI>
  );
};

export default ProductionDialog;
